import Tumer from 'src/assets/images/Tumer.svg';
import { useNavigate } from 'react-router-dom';

export const UnAuthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="text-center h-full flex justify-center items-center">
      <div className="w-[500px] h-[400px] bg-white box-shadow shadow-lg flex justify-center items-center flex-col gap-3 rounded-[8px]">
        <img src={Tumer} alt="tumer" />
        <h1 className="font-SFProDisplay font-black text-[32px] ">
          UnAuthorized
        </h1>
        <p
          className="font-SFProDisplay font-medium w-[372px]"
          onClick={() => navigate(-1)}
        >
          Please check with admin 101
        </p>
      </div>
    </div>
  );
};
